import { WorkerStage } from "@clipboard-health/contract-worker-app-bff";
import { type SxProps, type Theme } from "@mui/material";
import { CalloutsWrapper } from "@src/appV2/redesign/system/ui-components";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { AccountOnHoldCallout } from "../Charting/AccountOnHoldCallout";
import { EarlyAccessCallout } from "../EarlyAccessFacilities/components/Callout";
import { InHomeCallout } from "../InHome/Callout";
import { ShiftBlocksCallout } from "../Shift/Block/Callout";
import { BookingRequestsCallout } from "../Shift/BookingRequest/Callout";
import { ShiftInvitesCallout } from "../Shift/Invite/Callout";
import { PriorityShiftsCallout } from "../Shift/Priority/Callout";
import { ShiftTravelBlockCallout } from "../Shift/TravelBlock/Callout";
import { UrgentShiftsCallout } from "../Shift/Urgent/Callout";
import { AccountDeactivatedCallout } from "../Worker/AccountDeactivatedCallout";
import { WorkerAvailabilityCallout } from "../Worker/AvailabilityCallout";
import { FavoriteWorkplacesCallout } from "../Workplace/FavoriteWorkplacesCallout";
import { useGetFavoriteWorkplaceEntitlement } from "./FavoriteWorkplaces/useGetFavoriteWorkplaceEntitlement";

interface ShiftDiscoveryCalloutsContainerProps {
  priorityShiftsCount: number;
  urgentShiftsCount: number;
  blockShiftsCount: number;
  inHomeCount?: number;

  sx?: SxProps<Theme>;
}

export function ShiftDiscoveryCalloutsContainer(props: ShiftDiscoveryCalloutsContainerProps) {
  const { priorityShiftsCount, urgentShiftsCount, blockShiftsCount, inHomeCount, sx } = props;
  const { stage } = useDefinedWorker();
  const { isEntitlementEnabled: isFavoriteWorkplacesEnabled } =
    useGetFavoriteWorkplaceEntitlement();

  if (stage === WorkerStage.RESTRICTED) {
    return (
      <CalloutsWrapper sx={sx}>
        <AccountOnHoldCallout />
      </CalloutsWrapper>
    );
  }

  return (
    <CalloutsWrapper sx={sx}>
      <AccountDeactivatedCallout />
      <AccountOnHoldCallout />
      <UrgentShiftsCallout count={urgentShiftsCount} />
      <ShiftInvitesCallout />
      <PriorityShiftsCallout count={priorityShiftsCount} />
      <EarlyAccessCallout />
      {isFavoriteWorkplacesEnabled && <FavoriteWorkplacesCallout />}
      <InHomeCallout count={inHomeCount} />
      <ShiftBlocksCallout count={blockShiftsCount} />
      <WorkerAvailabilityCallout />
      <ShiftTravelBlockCallout />
      <BookingRequestsCallout />
    </CalloutsWrapper>
  );
}
